import React from "react"

import SelectTags from "../../../common/tags/SelectTags"

const KeyIssueEditRelatedInsightAreas = ({
    primaryTopic,
    relatedTopics,
    onTopicsSearch,
    onValueChange
}) => (
    <div className="widget">
        <div className="widget-content visible">
            <h3 className="first-heading">
                <span className="icon icon-insights" />Primary insight area
            </h3>
            <SelectTags
                name="primary_topic"
                multi={false}
                value={primaryTopic}
                placeholder="Add primary insight area"
                loadOptions={onTopicsSearch}
                onChange={onValueChange("primary_topic")}
            />
            <h3>
                <span className="icon icon-insights" />Related insight areas
            </h3>
            <SelectTags
                name="topics"
                value={relatedTopics}
                placeholder="Add related insight area"
                multi={true}
                loadOptions={onTopicsSearch}
                onChange={onValueChange("topics")}
            />
        </div>
    </div>
)

export default KeyIssueEditRelatedInsightAreas
